import { Link } from "react-router-dom";

export default function ProjectCard(content: { image: string, title: string, body: string, link: string, status: any }) {


	return (
		<div className="shadow-card card position-relative">
			<span className="position-absolute text-primary fw-bold bg-secondary p-2">For Lease</span>
			{/* <span className="position-absolute text-primary fw-bold bg-secondary p-2">{content.status === '1' ? 'For Sale' : (content.status === '2' ? 'For Lease' : 'N/A')}</span> */}
			<img loading="lazy" src={content.image} className="card-img-top img-hover-zoom img-fluid object-cover" style={{ height: "200px", width: "400px" }} alt={content.title} />
			<div className="card-img-overlay bg-dark bg-gradient opacity-25">
			</div>
			<div className="card-img-overlay d-flex flex-column-reverse">
				<h5 className="text-white m-2">{content.body}</h5>
				<Link to={content.link} className="stretched-link" aria-label={content.title}>
					<h5 className="card-title text-white fw-bolder m-2 fs-2">{content.title}</h5>
				</Link>
			</div>
		</div>
	)
}